@if (reports().length || loading() || error()) {
    <app-page-data-panel
        title="Legacy Schedule Completion Reports"
        subtitle="Previously issued schedule PDFs remain available. New completion reports are issued for the full POSM execution.">
        <div actions>
            <p-button label="Refresh" icon="pi pi-refresh" severity="secondary" [outlined]="true" [loading]="loading()" (onClick)="load()"></p-button>
        </div>

        @if (error()) {
            <div class="report-banner error"><i class="pi pi-exclamation-circle"></i><span>{{ error() }}</span></div>
        }
        @if (reports().length) {
            <div class="version-list">
                @for (report of reports(); track report.id || report.reportNumber) {
                    <article class="version-row">
                        <div class="version-badge">v{{ report.version || 1 }}</div>
                        <div class="version-main">
                            <strong>{{ report.reportNumber || 'Completion report' }}</strong>
                            <span>{{ report.generatedAt | date:'medium' }} · {{ generatedBy(report) }}</span>
                        </div>
                        <p-button icon="pi pi-download" label="Download" severity="secondary" [outlined]="true"
                            [loading]="reportActions.isPending(downloadActionKey(report))" (onClick)="download(report)"></p-button>
                    </article>
                }
            </div>
        } @else if (!loading()) {
            <div class="loading-state">No legacy schedule-level reports are available.</div>
        }
    </app-page-data-panel>
}
